module.exports = __webpack_public_path__ + "static/mid-section-texture-8478f0b0f144f01abb13723e77571235.png";